import {CART_ROOT_ELEMENT_ID} from 'lib/constants';
import {createContext, useContext} from 'react';

export function defineCartAuthFeature() {
    const cartRootElement = document.getElementById(CART_ROOT_ELEMENT_ID);
    const dataWithoutAuth = cartRootElement?.getAttribute('data-without-auth');
    const withAuth = dataWithoutAuth !== 'true';

    return withAuth;
}

export type CartAuthContextType = {
    /**
     * есть ли в корзине возможность аутентификации и использования логики
     * привязанной к сессии
     */
    withAuth: boolean;
};

export const CartAuthContext = createContext<CartAuthContextType>({
    withAuth: defineCartAuthFeature(),
});

export function useCartAuthContext() {
    return useContext(CartAuthContext);
}
